import React from "react";
import img3 from "../imgs/img5.png"; // smaller, lower image
import img4 from "../imgs/img6.png"; // bigger, upper image

export default function SideBySideImages() {
  return (
    <div className="w-[90%] flex flex-row mt-[4%] items-end justify-center gap-2 mx-auto ">
      {/* Smaller image */}
      <img
        src={img3}
        alt="Smaller Image"
        className="w-[40%] mt-[13%] object-contain"
      />

      {/* Bigger image */}
      <img
        src={img4}
        alt="Main Image"
        className="w-[45%] object-contain"
      />
    </div>
  );
}
